import { LocalStorage as _LocalStorage } from '@codeleap/web'

export const LocalStorageKeys = {
  SESSION_IS_DEV: '@Session.isDevelopment',
  TESTER: '@CodeleapTester',
  LOCALE: '@locale',
  PERSIST_AUTH: '@auth.has_user',
  ONBOARDING_FINISHED: '@Onboarding.finished',
  COLOR_SCHEME: '@ColorScheme',
  ONBOARDING: '@Onboarding'
}

export const LocalStorage = new _LocalStorage(LocalStorageKeys)
